module.exports = __webpack_public_path__ + "img/checked.6c594b26.svg";